
    <div class="ng2-pdf-viewer-container">
      <div class="pdfViewer"></div>
    </div>


// WEBPACK FOOTER //
// ./node_modules/ng2-pdf-viewer/ng2-pdf-viewer.d.ts.PdfViewerComponent.html